var _path, _ellipse, _ellipse2, _ellipse3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCookie = function SvgIconCookie(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5694 17.9408C36.5501 17.5846 36.1014 17.4177 35.7948 17.5999C35.2829 17.9041 34.6834 18.0791 34.0425 18.0791C32.6217 18.0791 31.4042 17.219 30.8941 15.9971C30.8 15.7717 30.5524 15.6379 30.3171 15.7032C29.675 15.8816 28.9977 15.9769 28.2979 15.9769C24.1851 15.9769 20.851 12.6827 20.851 8.61898C20.851 7.95743 20.9394 7.31627 21.1051 6.7064C21.1732 6.45576 21.0177 6.19374 20.7672 6.12547C18.6074 5.53707 17.0213 3.58209 17.0213 1.26106V1.26106C17.0213 1.06138 16.856 0.894927 16.6571 0.912394C7.32019 1.73224 0 9.48159 0 18.9203C0 28.9053 8.19224 36.9998 18.2979 36.9998C28.4035 36.9998 36.5957 28.9053 36.5957 18.9203C36.5957 18.5916 36.5869 18.2651 36.5694 17.9408Z",
    fill: "#7A7A7A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.383,
    cy: 2.52273,
    rx: 2.55319,
    ry: 2.52273,
    fill: "#7A7A7A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.234,
    cy: 10.091,
    rx: 1.70213,
    ry: 1.68182,
    fill: "#7A7A7A"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.0851,
    cy: 10.7216,
    rx: 1.91489,
    ry: 1.89205,
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6383 9.03991C10.6383 9.62043 10.162 10.091 9.57447 10.091C8.98694 10.091 8.51064 9.62043 8.51064 9.03991C8.51064 8.45938 8.98694 7.98877 9.57447 7.98877C10.162 7.98877 10.6383 8.45938 10.6383 9.03991ZM19.1489 15.7672C19.1489 17.741 17.5295 19.3411 15.5319 19.3411C13.5343 19.3411 11.9149 17.741 11.9149 15.7672C11.9149 13.7934 13.5343 12.1934 15.5319 12.1934C17.5295 12.1934 19.1489 13.7934 19.1489 15.7672ZM30.2128 24.5967C30.2128 26.1061 28.9744 27.3297 27.4468 27.3297C25.9192 27.3297 24.6808 26.1061 24.6808 24.5967C24.6808 23.0874 25.9192 21.8638 27.4468 21.8638C28.9744 21.8638 30.2128 23.0874 30.2128 24.5967ZM7.4468 23.1249C8.50437 23.1249 9.36169 22.2778 9.36169 21.2329C9.36169 20.1879 8.50437 19.3408 7.4468 19.3408C6.38923 19.3408 5.53191 20.1879 5.53191 21.2329C5.53191 22.2778 6.38923 23.1249 7.4468 23.1249ZM15.1064 29.4319C15.6939 29.4319 16.1702 28.9613 16.1702 28.3807C16.1702 27.8002 15.6939 27.3296 15.1064 27.3296C14.5188 27.3296 14.0426 27.8002 14.0426 28.3807C14.0426 28.9613 14.5188 29.4319 15.1064 29.4319Z",
    fill: "#525252"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCookie);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-cookie.f81655a8fcceea90ee357b5b7150c6a4.blank.svg";